import React, { useEffect } from 'react';
import { useIsAuthenticated, useMsal, useAccount } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import MainContent from '../components/layout/MainContent';
import useStore from '../store/useStore';
import { tokenRequest } from '../msalConfig';

const Dashboard = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { setUserId, setUserProfile } = useStore();

  useEffect(() => {
    // Actualizar el ID del usuario en el store cuando se autentique
    if (isAuthenticated && accounts && accounts.length > 0) {
      const activeAccount = accounts[0];
      // Establecer la cuenta activa
      instance.setActiveAccount(activeAccount);
      setUserId(activeAccount.homeAccountId);
      
      // Actualizar el perfil del usuario en el store
      if (activeAccount) {
        const userProfile = {
          id: activeAccount.homeAccountId,
          name: activeAccount.name || 'Usuario',
          email: activeAccount.username || '',
          // Agregar más campos según sea necesario
        };
        setUserProfile(userProfile);
        
        // Obtener el token de acceso con los ámbitos necesarios
        instance.acquireTokenSilent({
          ...tokenRequest,
          account: activeAccount
        }).catch(error => {
          console.error('Error al obtener el token de acceso:', error);
        });
      }
    }
  }, [isAuthenticated, accounts, instance, setUserId, setUserProfile]);

  // Redirigir a login si no está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Mostrar un indicador de carga mientras se carga la cuenta
  if (!account) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-700 dark:text-gray-300">Cargando información del usuario...</p>
        </div>
      </div>
    );
  }

  return <MainContent />;
};

export default Dashboard;
